import SmarteditController from '@/utils/Controllers/SmarteditController';

const styleVideo = () => {
  const faqContent = document.querySelector('.js-faq-article-content');
  if (faqContent) {
    const iFrame = faqContent.querySelectorAll('iFrame');
    if (iFrame) {
      iFrame.forEach(frame =>
        frame.parentElement.classList.add('dln-faq__video-container'),
      );
    }
  }
};

export default () => {
  SmarteditController.addOnReprocessPageListener(styleVideo);
  styleVideo();
};
